import { createChatBotMessage } from "react-chatbot-kit";
import COLORS from "../colors/colors";
import BotAvatar, { UserAvatar } from "../components/BotAvatar";

const config = {
  botName: "FISTalk",
  initialMessages: [
    createChatBotMessage(
      "Hi! Ask me about your transaction. e.g. TAG NUMBER 10739 RECEIPT UNOFFICIAL"
    ),
  ],
  customStyles: {
    botMessageBox: {
      backgroundColor: COLORS.ACCENT_COLOR,
    },
    userMessageBox: {
      backgroundColor: COLORS.PRIMARY_COLOR,
    },
    chatButton: {
      backgroundColor: COLORS.ACCENT_HOVER_DARK_COLOR,
    },

    chatWindow: {
      backgroundColor: COLORS.ACCENT_COLOR,
    },
  },
  customComponents: {
    botAvatar: (props) => <BotAvatar {...props} />,
    userAvatar: (props) => <UserAvatar {...props} />,
  },
};

export default config;
